import { useCallback, RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { focusToCell } from "src/utils/grid/GridHandlerContent";
import { MST4060_R01DetailDto } from "../Dto_MST4060_R01";

interface UseMST4060_R01ModalProps {
	updateMST4060_R01DetailList: (index: number, data: MST4060_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<MST4060_R01DetailDto> | null>;
}

// 상세 그리드의 거래처·등록자 코드 검색 팝업 상태와 결과 반영을 관리한다.
export function useMST4060_R01Modal({
	updateMST4060_R01DetailList,
	gridRef,
}: UseMST4060_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	// 팝업 종료 전에 그리드 편집 모드를 끝내 입력값 충돌을 방지한다.
	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);

	// 거래처 또는 등록자 검색 팝업을 열고 선택 결과를 대상 상세 행에 반영한다.
	const settingCodeSearchModalProps = useCallback(
		(
			category: string,
			search: string,
			isInfo: boolean,
			handleFoucsId: string,
			rowData: MST4060_R01DetailDto,
			valueIndex: number,
			originalData?: MST4060_R01DetailDto,
		) => {
			const baseData = originalData ?? rowData;
			const isInspectEmployee = handleFoucsId === "inspectEmpno";

			setCodeSearchModalProps({
				category,
				search,
				formName: "MST4060_R01",
				isInfo,
				handleFoucsId,
				wrapperOption: { size: "md", width: 50, overlay: true },
				onClear: () => {
					updateMST4060_R01DetailList(valueIndex, {
						...baseData,
						...(isInspectEmployee
							? { inspectEmpno: "", inspectEmpNm: "" }
							: { customCd: "", customNm: "" }),
						isModified: true,
					});
					handlePopupClose();
				},
				onConfirm: (data: any) => {
					updateMST4060_R01DetailList(valueIndex, {
						...rowData,
						...(isInspectEmployee
							? { inspectEmpno: data.empNo || "", inspectEmpNm: data.empNm || "" }
							: { customCd: data.customCd || "", customNm: data.customNm || "" }),
						isModified: true,
					});

					setTimeout(() => {
						if (!gridRef.current) return;
						focusToCell(gridRef, valueIndex, "remark");
					}, 100);
				},
			});
		},
		[setCodeSearchModalProps, updateMST4060_R01DetailList, gridRef, handlePopupClose],
	);

	return { settingCodeSearchModalProps, handlePopupClose };
}
